import {
  Box,
  Button,
  IconButton,
  InputLabel,
  Select,
  TextField,
  Checkbox,
  Radio,
  styled,
  MenuItem,
} from "@mui/material";
// import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InputMask from "react-input-mask";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Badge, { BadgeProps } from "@mui/material/Badge";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';

export function CustomLeftIcon(): JSX.Element {
  return (
    <KeyboardArrowLeftIcon
      sx={{
        background: "#F05802",
        fontSize: "14px",
        color: "white",
        width: "24px",
        height: "24px",
        cursor: "pointer",
        borderRadius: "50%",
      }}
    />
  );
}
export function CustomUpIcon(): JSX.Element {
  return (
    <KeyboardArrowUpIcon
      sx={{
        background: "#F05802",
        fontSize: "14px",
        color: "white",
        width: "16px",
        height: "16px",
        cursor: "pointer",
        borderRadius: "50%",
      }}
    />
  );
}
export function CustomDownIcon(): JSX.Element {
  return (
    <KeyboardArrowDownIcon
      sx={{
        background: "#F05802",
        fontSize: "14px",
        color: "white",
        width: "16px",
        height: "16px",
        cursor: "pointer",
        borderRadius: "50%",
      }}
    />
  );
}

export const CustomCheckbox = styled(Checkbox)`
  & svg {
    color: #f05802;
    height: 16px;
  }
`;
export const CustomRadioButton = styled(Radio)`
  & svg {
    color: #f05802;
    height: 24px;
    width: 24px;
  }
`;

export const CustomTextFeild = styled(TextField)`

.MuiFormControl-root {
    background-color: #fff9e4;
  }
  & input {
    overflow: unset;
    padding: 14px 16px;
    height: 20px !important;
    min-height: 0px !important;
    border-radius: 8px;
    background: #fff9e4;
    min-width: 0 !important;
    &::placeholder {
      color: #686868; // Example placeholder text color
      opacity: 0.5; // Adjust the opacity as needed
    }
  }
  & input:-webkit-autofill {
    /* Styles for autofill */
    border-radius: 8px;
    height: 20px;
    box-shadow: 0 0 0 30px #fff9e4 inset !important;
  }
  & fieldset {
    border-style: unset;
  }
  // & div {
  //    background-color: #fff9e4;
  // }
  & svg {
    background-color: #fff9e4;
  }
`;


export const CustomCityStateTextField = styled(CustomTextFeild)`
  & input:hover {
    cursor: not-allowed;
  }
`;

export const CustomTextFeildPooja = styled(CustomTextFeild)`
  & input {
    padding: 10px 16px;
  }
`;

export const CustomPasswordTextFeild = styled(TextField)`
  & input {
    // background-color: #fff9e4;
    width: 370px;
    padding: 14px 16px;
    border-radius: 8px;
    height: 20px;
    /* border: 1px solid rgba(136, 46, 20, 0.40); */
  }
  & fieldset {
    border-style: unset;
  }
`;

export const CustomTextFeildforFamily = styled(TextField)`
  & input {
    background-color: white;
    width: inherit;
    padding: 14px 16px;
    border-radius: 8px;
    height: 20px;
  }
  & fieldset {
    border-style: unset;
  }
`;

export const CustomTextFeildForHallSchedule = styled(CustomTextFeildforFamily)`
  & input {
    padding: 10px 16px;
    height: 15px;
  }
`;

export const CustomNumberFeildForHallSchedule = styled(InputMask)`
& input {
  background-color: white;
  padding: 10px 16px;
  height: 20px;
}
& fieldset {
  border-style: unset;
}
`;

export const CustomTextFeildForHallContract = styled(CustomTextFeildforFamily)`
  & input {
    padding: 10px 16px;
    height: 15px;
    width: 120px;
    border: 1px solid rgba(136, 46, 20, 0.40);
  }
`;

export const CommonButton = styled(Button)`
  border-radius: 4px;
  background: #f05802;
  display: inline-flex;
  padding: 8px 16px;
  height: 38px;
  box-shadow: none;
  width: auto;
  color: #fff;
  text-transform: capitalize;
  align-items: flex-start;
  text-align: center;
  gap: 10px;
  &:hover {
    color: #fff;
    background-color: #f05802;
  }
  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;
    background-color: #8a8d93;
    color: #fff;
  }
`;

export const CommonLogoutButton = styled(CommonButton)`
  color: #882E14;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  background: var(--Bg, #FFF9E4);
`

export const CommonDisableButton = styled(Button)`
  border-radius: 4px;
  background: #8a8d93;
  display: inline-flex;
  padding: 8px 16px;
  height: 38px;
  box-shadow: none;
  width: auto;
  color: #fff;
  text-transform: capitalize;
  align-items: flex-start;
  text-align: center;
  gap: 10px;
  &:hover {
    color: #fff;
    background-color: #f05802;
  }
  &:disabled {
    cursor: not-allowed;
    background-color: #f051026e;
    color: white;
  }
`;

export const CommonOutlinedButton = styled(Button)`
  border-radius: 4px;
  background: #ffffff;
  display: inline-flex;
  padding: 8px 16px;
  height: 38px;
  box-shadow: none;
  width: auto;
  color: #f05802;
  border: 1px solid #f05802;
  border-color: #f05802;
  text-transform: capitalize;
  align-items: flex-start;
  text-align: center;
  gap: 10px;
  &:hover {
    color: #fff;
    background-color: #f05802;
  }
  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;
    background-color: #8a8d93;
    color: #fff;
    border: 1px solid #8a8d93;
  }
`;

export const CommonOutlinedVerifiedButton = styled(Button)`
  border-radius: 4px;
  background: #ffffff;
  display: inline-flex;
  padding: 8px 16px;
  height: 38px;
  box-shadow: none;
  width: auto;
  color: green;
  border: 1px solid #f05802;
  border-color: green;
  text-transform: capitalize;
  align-items: flex-start;
  text-align: center;
  gap: 10px;
  &:hover {
    color: #fff;
    background-color: #f05802;
  }
`;

export const LeftAndRightStyledIconsButton = styled(IconButton)`
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  padding: 4px;
  background-color: #efe4c5;
  height: 30px;
  top: 95px;
`;
export const CustomSelect = styled(Select)`
  & svg {
    color: #f05802;
  }
  & div {
    overflow: unset;
    padding: 14px 16px;
    height: 20px !important;
    min-height: 0px !important;
    border-radius: 8px;
    background: #fff9e4;
    min-width: 0 !important;
    &:focus {
      border-radius: 8px !important; // Apply the border radius when focused
    }
  }
  & input {
    padding: 14px 16px;
    height: 20px;
    border-radius: 8px;
  }
  & fieldset {
    border-style: unset;
  }
`;

export const CustomSelectforPooja = styled(CustomSelect)`
  & div {
    padding: 10px 16px;
  }
  & input {
    padding: 10px 16px;
  }
`;

export const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: " #fff9e4 ",
  "&.MuiMenu-list": {
    paddingTop: 0,
    paddingBottom: 0,
  },
  "&:hover": {
    backgroundColor: "#882E14",
    color: "#fff",
  },
  "&.Mui-selected": {
    backgroundColor: " #e7856a",
    color: "#fff",
  },
}));

export const CustomSelectforFamily = styled(Select)`
  & svg {
    color: #f05802;
  }
  & div {
    overflow: unset;
    padding: 14px 16px;
    height: 20px !important;
    min-height: 0px !important;
    border-radius: 8px;
    background: white;
    min-width: 0 !important;
    // width: calc(100% - 30px);
    &:focus {
      border-radius: 8px !important; // Apply the border radius when focused
    }
  }
  & input {
    padding: 14px 16px;
    height: 20px;
  }
  &:focus {
    & input {
      border-radius: 8px; // Apply the border-radius when focused
    }
  }
  & fieldset {
    border-style: unset;
  }
`;

export const CustomSelectForHallContract = styled(CustomSelectforFamily)`
  & div {
    overflow: unset;
    padding: 14px 16px;
    height: 10px !important;
    min-height: 0px !important;
    border-radius: 8px;
    background: white;
    min-width: 0 !important;
    & input {
    padding: 14px 16px;
    /* height: 20px; */
    // width: calc(100% - 30px);
  }
    &:focus {
      border-radius: 8px !important; // Apply the border radius when focused
    }
  }
`;

export const StyledDateContainer = styled(Box)`
  & div {
    overflow: unset;
    padding-top: 0px;
    border-radius: 8px;
    min-width: 0 !important;
  }
`;
export const CustomInputLabel = styled(InputLabel)`
  color: #313131;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 2px;
`;

//Adding Star for the Required Feild
export const CustomRequiredInputLabel = (text: string, required: boolean) => {
  return (
    <CustomInputLabel sx={{ display: "flex", flexDirection: "row" }}>
      {text}
      {required && (
        <span style={{ width: "6px", height: " 12px", color: "#FF3A44" }}>
          *
        </span>
      )}
    </CustomInputLabel>
  );
};

// This is for Phone Number in US Format
export const ContactNumberInput = styled(InputMask)`
  background-color: #fff9e4;
  padding: 14px 14px;
  border-radius: 8px;
  height: 20px;
  &::placeholder {
    color: #686868; // Example placeholder text color
    opacity: 0.5; // Adjust the opacity as needed
  }
  border: 1px solid rgba(136, 46, 20, 0.4);
  & input {
    border: none !important;
    padding: 5px;
   
  }

  :hover {
    border: 1px solid rgba(136, 46, 20, 0.4);
  }
  :focus {
    outline: none;
  }
`;

// export const CustomDateRangePicker = styled(DateRangePicker)`
//    & div {
//       display: flex;
//       flex-direction: row;
//       align-items: center;
//       & input {
//          padding: 0px;
//          margin-bottom: -2px;
//          align-items: center;
//          font-size: 14px;
//          font-style: normal;
//          font-weight: 400;
//       }
//       & fieldset {
//          border-style: none;
//       }
//    }
// `;

export const CustomDatePicker = styled(DatePicker)`
  & div {
    display: flex;
    flex-direction: row;
    align-items: center;
    & input {
      padding: 14px 16px;
      height: 20px;
      align-items: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }
    :hover {
      /* border: 1px solid #F05802; */
    }
    & fieldset {
      border-style: none;
    }
  }
`;
export const CustomTimePicker = styled(TimePicker)`
  & div {
    display: flex;
    flex-direction: row;
    align-items: center;
    & input {
      padding: 14px 16px;
      height: 20px;
      align-items: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }
    & fieldset {
      border-style: none;
    }
  }
`;

export const CustomDateTimePicker = styled(DateTimePicker)`
  & div {
    display: flex;
    flex-direction: row;
    align-items: center;
    & input {
      padding: 0px;
      margin-bottom: -2px;
      align-items: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }
    & fieldset {
      border-style: none;
    }
  }
`;
//adding custom info for View  Request
export function CustomInfo(): JSX.Element {
  return (
    <InfoOutlinedIcon
      sx={{
        color: "#F05802",
        fontSize: "14px",
        width: "24px",
        height: "24px",
        // marginRight: '-6px',
        cursor: "pointer",
      }}
    />
  );
}
export function CustomCalendarIcon(): JSX.Element {
  return (
    <CalendarTodayOutlinedIcon
      sx={{
        color: "#22A699",
        fontSize: "14px",
        width: "16px",
        height: "16px",
        marginRight: "-6px",
        cursor: "pointer",
      }}
    />
  );
}

export function CustomCalendarIconForCalenderNext7Days(): JSX.Element {
  return (
    <CalendarTodayOutlinedIcon
    sx={{
      color: '#22A699',
      fontSize: '16px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
   }}
    />
  );
}

export function CustomCloseIcon(): JSX.Element {
  return (
    <CancelOutlinedIcon
      sx={{
        color: "#F05802",
        fontSize: "14px",
        width: "24px",
        height: "24px",
        marginRight: "-6px",
        cursor: "pointer",
      }}
    />
  );
}
export function CustomCalendarTodayOutlinedIcon(): JSX.Element {
  return (
    <CalendarTodayOutlinedIcon
      sx={{
        color: "#F05802",
        fontSize: "14px",
        width: "16px",
        height: "16px",
        marginRight: "0px",
        cursor: "pointer",
      }}
    />
  );
}

export function CustomEditIcon(): JSX.Element {
  return (
    <EditIcon
      sx={{
        color: "#F05802",
        fontSize: "14px",
        width: "16px",
        height: "16px",
        padding: "5px",
        marginRight: "-6px",
        cursor: "pointer",
      }}
    />
  );
}

export function CustomDeleteIcon(): JSX.Element {
  return (
    <DeleteIcon
      sx={{
        color: "#F05802",
        fontSize: "14px",
        width: "16px",
        height: "16px",
        padding: "5px",
        marginRight: "-6px",
        cursor: "pointer",
      }}
    />
  );
}

export function CustomTimeOutlinedIcon(): JSX.Element {
  return (
    <AccessTimeOutlinedIcon
      sx={{
        color: "#F05802",
        fontSize: "14px",
        width: "16px",
        height: "16px",
        marginRight: "0px",
        cursor: "pointer",
      }}
    />
  );
}

export function CustomLocationOutlinedIcon(): JSX.Element {
  return (
    <PlaceOutlinedIcon
      sx={{
        color: "#22A699",
        fontSize: "14px",
        width: "18px",
        height: "18px",
        marginRight: "0px",
        cursor: "pointer",
      }}
    />
  );
}

export function CustomCalendarOutlinedIcon(): JSX.Element {
  return (
    <CalendarTodayOutlinedIcon
      sx={{
        color: "#22A699",
        fontSize: "14px",
        width: "18px",
        height: "18px",
        marginRight: "0px",
        cursor: "pointer",
      }}
    />
  );
}
export const CustomSearchFeild = styled(TextField)`
  & input {
    border-radius: 8px;
  }
  & fieldset {
    border-style: unset;
  }
  & placeholder {
    color: black;
  }
`;
export const CustomBadge = styled(Badge)<BadgeProps>(({}) => ({
  "& .MuiBadge-badge": {
    padding: "0 4px",
    backgroundColor: "#F05802",
    color: "#fff",
  },
}));

export const HcccCard = styled(Box)`
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 20px 0px rgba(237, 237, 237, 0.8);
  margin-top: 15px;
  // padding: 24px;
`;

export function CustomAddCircleIcon(): JSX.Element {
  return (
    <AddCircleIcon
      sx={{
        // background: '#F05802',
        fontSize: "14px",
        color: "#F05802",
        width: "20px",
        height: "20px",
        cursor: "pointer",
      }}
    />
  );
}
export function CustomDeleteCircleIcon(): JSX.Element {
  return (
    <RemoveCircleOutlineIcon
      sx={{
        // background: '#F05802',
        fontSize: "14px",
        color: "#F05802",
        width: "20px",
        height: "20px",
        cursor: "pointer",
      }}
    />
  );
}

export function CustomReceiptIcon(): JSX.Element {
  return (
    <ReceiptOutlinedIcon
      sx={{
        // background: '#F05802',
        fontSize: "14px",
        color: "#22A699",
        width: "16px",
        height: "16px",
        cursor: "pointer",
      }}
    />
  );
}

export const formatAmount = (amount: any) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(amount);
};
